export const WatchLaterLearningContentTypeMap = {
  LESSON: 'lesson',
  TRACK: 'track',
  SHORT_FORM_CONTENT: 'short',
  COURSE: 'track',
  PLAYLIST: 'playlist',
  LEARNING_PATH: 'learningPath'
};